import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearStats } from "../state/userStats/actions";

export function useVerifyToken() {
  const history = useHistory();
  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();

  useEffect(() => {
    let isMounted = true;
    if (!token && isMounted) {
      dispatch(clearStats());
      history.push("/login");
    }

    return () => {
      isMounted = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
}
